// Comments are never removed from the database, only flagged `deleted`, so what
// appears on screen is decided here rather than by the absence of a record.
//
// Deleting a comment takes down that comment alone. Its replies belong to their
// own authors and survive, which leaves a gap in the thread: a reply reads as an
// answer to something. A deleted comment therefore stays on screen as an
// anonymous placeholder for exactly as long as it is holding replies up, and
// disappears once none are left.
//
// All of these expect comments already sorted newest first, as the section
// sorts them, and they preserve that order.

export function visibleComments(comments) {
    return comments.filter((comment) => !comment.deleted);
}

// Oldest first, so a thread reads downwards under its parent.
export function repliesTo(comments, commentKey) {
    return comments
        .filter((comment) => !comment.deleted && comment.parent === commentKey)
        .reverse();
}

export function topLevelComments(comments) {
    return comments.filter(
        (comment) =>
            comment.parent === undefined &&
            (!comment.deleted || repliesTo(comments, comment.key).length > 0),
    );
}
